import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ApplicationRoleImportTypeCreateModel {
    applicationRoleId: number
    importTypeId: number
}

export interface Props extends PopupProps {
    applicationRoleId: number
}

const AddApplicationRoleImportTypePopup: React.FC<Props> = ({ show, onHide, applicationRoleId }) => {
    const { handleResult, handleException } = useNotifications();
    const [serverErrors, setServerErrors] = useState<DataResult<ApplicationRoleImportTypeCreateModel>>({ isSuccesful: true, messages: [], data: undefined });

    const exportTypes = useSelectListOptions('api/v1/selectlist/ImportTypes', '-- Select import type');

    const [formData, setFormData] = useState<ApplicationRoleImportTypeCreateModel>({
        applicationRoleId: applicationRoleId,
        importTypeId: 0
    });

    function submit() {
        if (formData) {
            DataService
                .create<ApplicationRoleImportTypeCreateModel>(`api/v1/ApplicationRoleImportTypes`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'importTypeId', label: 'Import type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add import type'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('importTypeId')} options={exportTypes} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddApplicationRoleImportTypePopup;